

import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Navbar from '../navbar/Navbar';
import "./socailmedia.css";
import Formpage from '../Formpage/Formpage';
import AOS from "aos";
import "aos/dist/aos.css";



const items = [
  {
    title: 'Basic Plan',
    description: [
      'Ideal for Startups & Small Businesses',
      '2 Platforms (e.g., Facebook & Instagram)',
      '8 Posts/Month (Graphics + Captions)',
      'Hashtag Strategy',
      'Basic Scheduling',
      'Monthly Performance Report',
    ],
    img: 1,
  },
  {
    title: 'Standard Plan',
    description: [
      'Perfect for Growing Brands',
      '3 Platforms',
      '12–15 Posts/Month',
      '4 Stories/Month',
      'Basic Ad Management (₹2K Ad Budget Suggested)',
      'Engagement Monitoring (likes, comments)',
      'Monthly Analytics & Suggestions',
    ],
    img: 2,
  },
  {
    title: 'Professional Plan',
    description: [
      'For Serious Digital Presence',
      'Up to 4 Platforms',
      '20+ Posts/Month',
      '8 Stories + 2 Reels/Month',
      'Advanced Ad Management (₹5K–₹10K Budget)',
      'Lead Generation Campaign Setup',
      'Competitor & Trend Analysis',
      'Bi-weekly Report & Strategy Call',
    ],
    img: 3,
  },
  {
    title: 'Premium Plan',
    description: [
      'For Brands Needing High-Impact Digital Growth',
      'All Major Platforms (FB, Insta, LinkedIn, Twitter, YouTube)',
      '30+ Posts/Month',
      '12 Stories + 4 Reels/Month',
      'Full Funnel Ad Strategy + Lead Nurturing',
      'Social Media Inbox Management',
      'Monthly Photoshoot or Video Shoot (local only)',
      'Weekly Reports + Dedicated Account Manager',
    ],
    img: 4,
  },
  {
    title: 'Add-Ons',
    description: [
      'Influencer Collaboration',
      'WhatsApp Marketing',
      'Content Reels Creation',
      'Blog Content Writing',
      'Website SEO Integration',
    ],
    img: 5,
  },
];


function Socialmedia() {
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    centerMode: true,
    centerPadding: '0px',
    arrows: true,
    initialSlide: 0,

    responsive: [
      {
        breakpoint: 992, // tablet and below
        settings: {
          slidesToShow: 2,
          arrows: false,
          centerMode: false
        }
      },
      {
        breakpoint: 576, // mobile
        settings: {
          slidesToShow: 1,
          arrows: false,
          centerMode: false
        }
      }
    ]
  };
    useEffect(() => {
          AOS.init({
            duration: 1000,
            once: true,
          });
      
          setTimeout(() => {
            AOS.refresh();
          }, 500);
        }, []);


  return (
    <>
      <Navbar />
      <div className="container-fluid web-container" >
        <div className="wrapper">
          <section className='section-margin'>
            <center>
              <div className='heading-for-all' data-aos="fade-up">
                <h2>social media</h2>
              </div>
            </center>
          </section>

          <Slider {...settings} className="news-slider">
            {items.map((item, index) => (
              <div className="news-slider__item" key={index}>
                <div className="news__item news__item1" data-aos="fade-up" data-aos-delay="1000">
                  <div className="news__title">{item.title}</div>
                  <ul className="news__txt">
                    {item.description.map((point, idx) => (
                      <li key={idx}>{point}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </Slider>

        </div>

        <div
                    className="container d-flex justify-content-center my-4"
                    data-aos="fade-up"
                    data-aos-delay="1000"
                >
                    <button className="btn-15" onClick={handleShow}>
                        Get Enquiry
                    </button>
                </div>
      </div>

      <Formpage show={show} onClose={handleClose} />
    </>
  );
}

export default Socialmedia;

